import { Component, OnInit,ViewChild,ElementRef, Inject } from '@angular/core';
import { IdDescricao } from '@app/models/util/id-descricao';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { MetaVisaoAnualDTO } from '@app/pages/relatorios/meta-novos-processos/meta-visao-anual/relatorio-meta-visao-anual';
import { ToastrService } from 'ngx-toastr';
import { ConsultasService } from '@app/services/consultas.service';
import { MetaService } from '@app/services/meta.service';
import { Meta } from '@app/models/meta.model';
import { Unidade } from '@app/models/unidade.model';
import { UnidadeService } from '@app/services/unidade.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-meta-form',
  templateUrl: './meta-form.component.html',
  styleUrls:['./meta-form.scss' ]
})
export class MetaFormComponent implements OnInit {
 
  anoMeta: number;
  unidade: number;

  janeiroMeta: number;
  fevereiroMeta: number;
  marcoMeta: number;
  abrilMeta: number;
  maioMeta: number;
  junhoMeta: number;
  julhoMeta: number;
  agostoMeta: number;
  setembroMeta: number;
  outubroMeta: number;
  novembroMeta: number;
  dezembroMeta: number;

  lstUnidades: IdDescricao[];
  unidadeSelecionada: number;

  filtroDescricao: string ="";
  
  meta: Meta = new Meta();


  constructor(
    private _metaService: MetaService,
    private _consultasService: ConsultasService,
    @Inject(ToastrService) private toastr: ToastrService,
    private _unidadeService: UnidadeService,
    private _router:Router)
    { 
    
  }

  ngOnInit(): void {
    this._consultasService.consultar('UNIDADE_S_RATEIO').subscribe(data => this.lstUnidades = data);
  }

  gravarMetas(){
   //popula o objeto meta para usar o metodo do service
    this.meta.UnidadeId = this.unidadeSelecionada;
    this.meta.Ano = this.anoMeta;
    this.meta.JaneiroMeta = this.janeiroMeta;
    this.meta.FevereiroMeta = this.fevereiroMeta;
    this.meta.MarcoMeta = this.marcoMeta;
    this.meta.AbrilMeta = this.abrilMeta;
    this.meta.MaioMeta = this.maioMeta;
    this.meta.JunhoMeta = this.junhoMeta;
    this.meta.JulhoMeta = this.julhoMeta;
    this.meta.AgostoMeta = this.agostoMeta;
    this.meta.SetembroMeta = this.setembroMeta;
    this.meta.OutubroMeta = this.outubroMeta;
    this.meta.NovembroMeta = this.novembroMeta;
    this.meta.DezembroMeta = this.dezembroMeta;
    //chama o metodo gravar da service 
    this._metaService.gravar(this.meta).toPromise().then(
      data=>{
        this.toastr.success("Meta gravada com sucesso");
        setTimeout(() => {
          this._router.navigate(['/configuracoes/metas']);
        }, 5000); //voltar para tela de metas
      },
      erro => {
        this.toastr.warning(erro.error.errors[0])
      }
    );
  }
}
